// extracted by mini-css-extract-plugin
module.exports = {"inputStyle":"sxInput_inputStyle__1zFzc"};